import React from "react";
import { Link } from "gatsby";

const KeywordList = ({ keywords }) => (
  <div>
    <h3>Keywords:</h3>
    <ul>
      {keywords.map((keyword) => (
        <li key={keyword._id}>
          <Link to={`/keyword/${keyword._id}`}>{keyword.title}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export default KeywordList;
